import React, { Component } from "react";
import { registerForLocalization, provideLocalizationService } from "@progress/kendo-react-intl";
import LoadingPanel from "../../common/LoadingPanel";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { vlnyController } from "../../../controllers/vlny.controller";

class ZoznamVlnaArtikle extends Component {
    state = {
        items: [],
        loading: true,
        selectedArtikelId: null,
        title: null
    };

    shouldComponentUpdate(nextProps) {
        if (this.props.selectedVlnaId !== nextProps.selectedVlnaId) {
            this.getZoznamVlnArtikle(nextProps.selectedVlnaId);
            return false;
        }
        return true;
    }

    getZoznamVlnArtikle(idVlna) {
        vlnyController.getZoznamVlnaArtikle(idVlna).then(response => {
            let data = JSON.parse(JSON.stringify(response));
            var selectedArtikelId = data[0] ? data[0].idKarty : null;
            this.props.changeSelectedArtikelId(selectedArtikelId);
            this.setState({
                items: data,
                loading: false,
                selectedArtikelId: selectedArtikelId
            });
        });
    }

    renderTable(state) {
        var localizationService = provideLocalizationService(this);
        const { items } = state;
        return (
            <div id="ZoznamVlnaArtikle">
                <Grid
                    data={items.map(item => ({ ...item, selected: item.idKarty === state.selectedArtikelId }))}
                    total={items ? items.length : 0}
                    pageSize={items ? items.length : 0}
                    pageable={{ buttonCount: 0, info: true, pageSizes: false, previousNext: false }}
                    selectedField="selected"
                    onRowClick={e => {
                        this.props.changeSelectedArtikelId(e.dataItem.idKarty);
                        this.setState({
                            selectedArtikelId: e.dataItem.idKarty
                        });
                    }}>
                    <GridColumn field="vlna" title={localizationService.toLanguageString("VlnaArtikly.Grid.Vlna", "Vlna")} width="50px" />
                    <GridColumn field="artikle" title={localizationService.toLanguageString("VlnaArtikly.Grid.Artikle vo vlne", "Artikle vo vlne")} />
                    <GridColumn field="stav" title={localizationService.toLanguageString("VlnaArtikly.Grid.Stav ks", "Stav ks")} width="60px" />
                </Grid>
            </div>
        );
    }

    render() {
        let contents = this.state.loading ? <LoadingPanel /> : this.renderTable(this.state);

        return <div>{contents}</div>;
    }
}

export default ZoznamVlnaArtikle;

registerForLocalization(ZoznamVlnaArtikle);



// WEBPACK FOOTER //
// ./src/components/dialogs/Vlny/ZoznamVlnaArtikle.js